export const REQUEST_LISTS_CONTENT = "REQUEST_LISTS_CONTENT";
export const SET_LISTS_CONTENT = "SET_LISTS_CONTENT";
export const REVOKE_LISTS_CONTENT = "REVOKE_LISTS_CONTENT";
export const RESET_LISTS_CONTENT = "RESET_LISTS_CONTENT";

export const CHANGE_LISTS_MODALS = "CHANGE_LISTS_MODALS";

export const SET_ACTIVE_LIST_ID = "SET_ACTIVE_LIST_ID";
export const RESET_ACTIVE_LIST_ID = "RESET_ACTIVE_LIST_ID";

export const REQUEST_DELETE_LIST = "REQUEST_DELETE_LIST";
export const REVOKE_DELETE_LIST = "REVOKE_DELETE_LIST";
export const RESET_DELETE_LIST = "RESET_DELETE_LIST";
export const GRANT_DELETE_LIST = "GRANT_DELETE_LIST";

export const SET_ACTIVE_LIST_DISPLAY = "SET_ACTIVE_LIST_DISPLAY";
export const RESET_ACTIVE_LIST_DISPLAY = "RESET_ACTIVE_LIST_DISPLAY";

export const REQUEST_UPDATE_LIST = "REQUEST_UPDATE_LIST";
export const REVOKE_UPDATE_LIST = "REVOKE_UPDATE_LIST";
export const RESET_UPDATE_LIST = "RESET_UPDATE_LIST";
export const GRANT_UPDATE_LIST = "GRANT_UPDATE_LIST";

export const APPEND_LISTS_DELETION_ARRAY = "APPEND_LISTS_DELETION_ARRAY";
export const SUBTRACT_LISTS_DELETION_ARRAY = "SUBTRACT_LISTS_DELETION_ARRAY";

export const REQUEST_DELETE_LIST_ARRAY = "REQUEST_DELETE_LIST_ARRAY";
export const REVOKE_DELETE_LIST_ARRAY = "REVOKE_DELETE_LIST_ARRAY";
export const RESET_DELETE_LIST_ARRAY = "RESET_DELETE_LIST_ARRAY";
export const GRANT_DELETE_LIST_ARRAY = "GRANT_DELETE_LIST_ARRAY";
